import Pagination from '@mui/material/Pagination';

import { CustomPaginationProps } from 'types/pagination';

import theme from '../../../themes/colors';

const CustomPagination = ({
  totalCount,
  limit,
  page,
  setPage
}: CustomPaginationProps) => {
  const pageCount = Math.ceil(totalCount / limit);

  const handlePageChange = (_event: any, value: number) => {
    setPage(value);
  };

  return (
    <div className="flex items-center justify-center gap-4">
      <Pagination
        count={pageCount}
        page={page}
        onChange={handlePageChange}
        shape="rounded"
        hideNextButton
        hidePrevButton
        siblingCount={1}
        boundaryCount={1}
        sx={{
          '& .MuiPaginationItem-root.Mui-selected': {
            backgroundColor: theme.primary100,
            color: theme.primary110
          }
        }}
      />
    </div>
  );
};

export default CustomPagination;
